import { RescheduleLinkedAppointmentPayload } from "./../RescheduleLinkedAppointment/rescheduleLinkedAppointment.types";
import { CreateAppointmentPayload } from "../CreateAppointment/createAppointment.types";
import { RescheduleAppointmentPayload } from "../RescheduleAppointment/rescheduleAppointment.types";

/**
 * Retrieves the after care message from the response, concatenated together into a string if
 * more than 1 after care message is present.
 *
 * @param {CreateAppointmentPayload | RescheduleAppointmentPayload} response  Response from /CreateAppointment and /RescheduleAppointment
 *
 * @returns {string | null} After care messages, joined together from the API response
 */
const formatAfterCareMessage = (
  response:
    | CreateAppointmentPayload
    | RescheduleAppointmentPayload
    | RescheduleLinkedAppointmentPayload,
) => {
  if (response.PatientInstruction) {
    return response.PatientInstruction;
  }

  return null;
};

export { formatAfterCareMessage };
